import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ICustomConfigurationRepository } from '../../repositories/interfaces/iCustomConfigurationRepository';
import { IBigScreenCmsGamesResponse } from '../../../entity/interface/iBigScreenCmsMoods';

export interface IGetGamesUseCase {
    execute(): Promise<IBigScreenCmsGamesResponse>;
}

export class GetGamesUseCase implements IGetGamesUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get customConfigurationRepository(): ICustomConfigurationRepository {
        return container.resolve<ICustomConfigurationRepository>(DI.REPOSITORIES.ICustomConfigurationRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(): Promise<IBigScreenCmsGamesResponse> {
        const response = await this.customConfigurationRepository.getGames();
        return response;
    }
}
